var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconRecognition = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24px",
  height: "24px",
  viewBox: "0 0 24 24",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M-3313-12479a1,1,0,0,1-1-1,1,1,0,0,1,1-1h3v-3a1,1,0,0,1,1-1,1,1,0,0,1,1,1v4a1,1,0,0,1-1,1Zm-14,0a1,1,0,0,1-1-1v-4a1,1,0,0,1,1-1,1,1,0,0,1,1,1v3h3a1,1,0,0,1,1,1,1,1,0,0,1-1,1Zm1-9a1,1,0,0,1-1-1,1,1,0,0,1,1-1h16a1,1,0,0,1,1,1,1,1,0,0,1-1,1Zm16-6v-3h-3a1,1,0,0,1-1-1,1,1,0,0,1,1-1h4a1,1,0,0,1,1,1v4a1,1,0,0,1-1,1A1,1,0,0,1-3310-12494Zm-18,0v-4a1,1,0,0,1,1-1h4a1,1,0,0,1,1,1,1,1,0,0,1-1,1h-3v3a1,1,0,0,1-1,1A1,1,0,0,1-3328-12494Z",
  transform: "translate(3330 12501)",
  fill: "currentColor"
})));

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconRecognition, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-recognition.cbdf1573.svg";
export { ForwardRef as ReactComponent };